<template>
    <div class="page white_bg max425 centered">
        <div style="height: 46px; line-height: 46px;">
            <header class="pageHeader paddingH16 paddingV8 white_bg">
                <div class="borderLayout">
                    <div class="middleRegion">
                        <div class="westRegion" style="width: 60px">
                            <span class="icon leftAngleBracketIcon floatL" style="margin-top: 4px;" @click="back();"></span>
                        </div>
                        <div class="centerRegion alignCenter font18r primaryTextColor bold"
                             style="height: 30px; overflow: hidden">
                            {{title}}
                        </div>
                        <div class="eastRegion font14r alignRight" style="width: 60px">
                        </div>
                    </div>
                </div>
            </header>
        </div>
<!--        <div v-if="pdfUrl">-->
<!--            <div class="hiddenOverflow">-->
<!--                <pdfViewer :src="pdfUrl" :page="currentPage"-->
<!--                           @num-pages="pageCount = $event" @page-loaded="currentPage = $event"></pdfViewer>-->
<!--            </div>-->
<!--            <div class="alignC padding12">-->
<!--                <span class="optButton" @click="prevPage()">上一页</span>-->
<!--                {{currentPage}} / {{pageCount}}-->
<!--                <span class="optButton" @click="nextPage()">下一页</span>-->
<!--            </div>-->
<!--        </div>-->

        <div class="paddingH12 paddingV8">
            <article class="article">
                <div class="content">
                    <p v-for="(imageItem, i) in guideImages" :key="i">
                        <img :src="imageItem.url" :alt="imageItem.name"/>
                    </p>
                </div>
            </article>
        </div>

        <bottomMenu ref="bottomMenu" activePath="/me"></bottomMenu>

    </div>

</template>

<script>
import shixunPagePart from '@/components/shixunApp/shixunPagePart';

// modules
import Vue from 'vue';
import imageViewer from "vue-image-viewer";

Vue.use(imageViewer);

import bottomMenu from '@comp/bottomMenu.vue';
import pdfViewer from 'vue-pdf'

import arrayHelper from "@util/arrayHelper";

const config = {
    apiConfig : {
        // get : {
        //     url : 'portal/about/getGuide'
        // }
    }
}

export default {
    extends : shixunPagePart,
    name: "guide",
    components : {
        pdfViewer, bottomMenu,
    },
    data() {
        return {
            pdfUrl : '',
            currentPage : 1,
            pageCount : 1,

            guideImages : [{
                name : '',
                url : 'guide/01.png'
            },{
                name : '',
                url : 'guide/02.png'
            },{
                name : '',
                url : 'guide/03png'
            },{
                name : '',
                url : 'guide/04.png'
            },{
                name : '',
                url : 'guide/05.png'
            },
            ]

            // apiConfig : config.apiConfig,
            // enableDataItem : true
        }
    },
    methods : {
        viewImage(imageItem) {
            const me = this;
            me.$imageViewer.images(me.guideImages);
            me.$imageViewer.index(arrayHelper.getIndex(me.guideImages, imageItem));
            me.$imageViewer.show();
        },
        prevPage() {
            if (this.currentPage == 1)
            {
                return;
            }
            this.currentPage--;
        },
        nextPage() {
            if (this.currentPage == this.pageCount)
            {
                return;
            }
            this.currentPage++;
        }
    },
    mounted() {
        // this.pdfUrl = './guide/linux_note.pdf';
        // this.loadDataItem();
    }
}
</script>

<style scoped>
.optButton {
    padding: 0 32px;
}
</style>